import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    color?: string;
    className?: string;
    isPartnerTerms?: boolean;
    sourceForm?: {
        source: string;
        isUserLogged?: boolean;
    };
}
export const ApplicationTermsAcceptation: React.FunctionComponent<IProps> = (props) => {
    const pdfLink = rpAppLink.partnersTerms.base();
    const termsLink = props.isPartnerTerms ? pdfLink : rpAppLink.termsOfService.base();

    return (
        <Text variant="info_txt_1" color={props.color || "var(--colors-gray-700)"} className={props.className} align="center">
            Akceptuję{" "}
            <a href={termsLink} target="_blank" className={linkStyle}>
                regulamin{props.sourceForm?.source === "applicationSideBar" && !props.sourceForm?.isUserLogged ? "" : " serwisu."}
            </a>
            {props.sourceForm?.source === "applicationSideBar" && !props.sourceForm?.isUserLogged ? " i zakładam konto w Portalu." : ""}
        </Text>
    );
};

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "underline",
        color: "var(--colors-gray-700)"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    color?: string;
    className?: string;
    isPartnerTerms?: boolean;
    sourceForm?: {
        source: string;
        isUserLogged?: boolean;
    };
}
export const ApplicationTermsAcceptation: React.FunctionComponent<IProps> = (props) => {
    const pdfLink = rpAppLink.partnersTerms.base();
    const termsLink = props.isPartnerTerms ? pdfLink : rpAppLink.termsOfService.base();

    return (
        <Text variant="info_txt_1" color={props.color || "var(--colors-gray-700)"} className={props.className} align="center">
            Akceptuję{" "}
            <a href={termsLink} target="_blank" className={linkStyle}>
                regulamin{props.sourceForm?.source === "applicationSideBar" && !props.sourceForm?.isUserLogged ? "" : " serwisu."}
            </a>
            {props.sourceForm?.source === "applicationSideBar" && !props.sourceForm?.isUserLogged ? " i zakładam konto w Portalu." : ""}
        </Text>
    );
};

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "underline",
        color: "var(--colors-gray-700)"
    }
});
